import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles.tags';

const Partner: FC = () => {
  const { translate } = useI18nContext();
  return (
    <Style.Partner id="partner-tag">
      <img id="partner-tag-image" src={ImagesApp.svg.partner} alt="Partner" />
      <span id="partner-tag-text">{translate(['TAGS', 'MEMBERS'])}</span>
    </Style.Partner>
  );
};

export default Partner;
